import { ComponentPropsWithoutRef, forwardRef } from 'react'
import { Link } from 'tusk-ui'

const JumpLink = forwardRef<HTMLAnchorElement, ComponentPropsWithoutRef<typeof Link>>((props, ref) => {
    const { to, ...restProps } = props
    return <Link ref={ref} to={to} {...restProps} />
})

export default JumpLink
